// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingProvider } from "./contexts/SettingContext";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { SocketProvider } from "./contexts/socketContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SocketProvider>
      <AuthProvider>
        <SettingProvider>
          <App />
        </SettingProvider>
      </AuthProvider>
    </SocketProvider>
  </Provider>
);

reportWebVitals();
